import React, { useState } from "react";

const CardFaq = ({ title, content }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleFAQ = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <div
      className={`border-style-decoration backdrop-blur-sm justify-between flex transition-all ${
        isOpen
          ? "p-5 lg:px-10 bg-white/5"
          : "p-5 lg:px-10"
      } gap-12`}
    >
      <div className="w-full">
        <div className="flex justify-between items-center w-full gap-x-5">
          <h4 className="text-base lg:text-xl text-white">{title}</h4>

          <div className={`${isOpen ? "" : ""}`}>
            <button
              onClick={toggleFAQ}
              className={`border-style-decoration w-[42px] h-[42px] lg:w-[54px] lg:h-[54px] flex justify-center items-center ${isOpen ? "bg-primary-gradient" : ""
                }`}
            >
              <img
                src={
                  isOpen
                    ? "/assets/icons/icon-remove.svg"
                    : "/assets/icons/icon-add-bold.svg"
                }
                className="max-w-[20px] lg:max-w-[unset]"
                alt={isOpen ? "Remove Icon" : "Add Icon"}
              />
            </button>
          </div>
        </div>

        {isOpen && (
          <p className="text-white/60 leading-[1.4] mt-4 text-xs lg:text-base pr-20">
            {content}
          </p>
        )}
      </div>
    </div>
  );
};

export default CardFaq;
